import { PaneLayoutInteractionType } from '@eventbrite/eds-modal';
import { getPaneInteractionType } from './getPaneInteractionType';
import { getFooterHeight } from './rebrand';

export const getPaneCollapsibleOffsetForTicketSelection = () =>
    getPaneInteractionType() === PaneLayoutInteractionType.asCollapsible
        ? getFooterHeight()
        : 0;
